import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../theme';
import ChatContainer from '../ChatContainer';
import MessageBox from '../MessageBox';

const ChatView: React.FC = () => {
  const theme = useTheme();

  return (
    <Wrapper $theme={theme}>
      <ChatContainer />

      {/* Sticky MessageBox at bottom */}
      <MessageBox isSticky={true} placeholder="Ask another question…" />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $theme: any }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${(props) => props.$theme.colors.mainBg};
  color: ${(props) => props.$theme.colors.mainText};
  position: relative;
  overflow: hidden;
  font-size: 16px; /* Override global font-size */
`;

export default ChatView;
